import { useEffect, useState } from "react";
import { Space, Typography } from "antd";
import PageLoader from "Components/PageLoader/PageLoader";
import AccountDetailView from "Components/AccountDetailView/AccountDetailView";
import { getServiceAccount } from "services/serviceAccount.service";
import { renderErrorNotifications } from "helpers/error.helpers";
import ApplicationStatusBanner from "./_blocks/ApplicationStatusBanner";

const { Title, Text } = Typography;

function ApplicationView() {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    const { data, errors } = await getServiceAccount();
    if (errors?.length) renderErrorNotifications(errors);
    else setAccount(data);
    setLoading(false);
  }

  useEffect(() => {
    load();
  }, []);

  if (loading)
    return <PageLoader showCards={false} showHero={false} showTabs={false} />;

  return (
    <Space direction="vertical" size={24} style={{ width: "100%" }}>
      <div>
        <Title level={3} style={{ margin: 0 }}>
          My Application
        </Title>
        <Text type="secondary">
          Your submitted application and account details.
        </Text>
      </div>

      {account ? (
        <>
          <ApplicationStatusBanner
            status={account.verification_status}
            reason={account.reason_for_rejection}
          />
          <AccountDetailView account={account} />
        </>
      ) : (
        <ApplicationStatusBanner status="PENDING" />
      )}
    </Space>
  );
}

export default ApplicationView;
